class CacheActivePromiseError extends Error {
    constructor(text) {
        super(text);
    }
}
export function CacheActivePromise(argumentSerializer) {
    const cacheStorage = new WeakMap();
    const getCache = (ctx) => {
        let cache = cacheStorage.get(ctx);
        if (!cache) {
            cache = new Map();
            cacheStorage.set(ctx, cache);
        }
        return cache;
    };
    return function CacheActivePromiseDecorator(ctx, fieldName, propertyDescriptor) {
        const ctxName = ctx?.constructor?.name ?? '';
        const method = propertyDescriptor.value;
        if (method === undefined) {
            throw new CacheActivePromiseError(`Method ${fieldName} is undefined.`);
        }
        if (typeof method !== 'function') {
            throw new CacheActivePromiseError(`${fieldName} is not a function`);
        }
        propertyDescriptor.value = function (...args) {
            const cache = getCache(this);
            const keyArgs = argumentSerializer
                ? argumentSerializer(...args)
                : JSON.stringify(args, stringifyReplacer);
            const key = `${ctxName}.${fieldName}(${keyArgs})`;
            if (cache.has(key)) {
                return cache.get(key);
            }
            const result = method.apply(this, args).finally(() => cache.delete(key));
            if (typeof result.then !== 'function') {
                throw new CacheActivePromiseError(`Method ${fieldName} return not promise`);
            }
            cache.set(key, result);
            return result;
        };
        return propertyDescriptor;
    };
}
function stringifyReplacer(_, value) {
    return typeof value === 'bigint' ? value.toString() : value;
}
//# sourceMappingURL=cache-active-promise.js.map